import React from 'react';
import { Link } from "react-router-dom";
import './ItemProducts.css';

const ItemProduct = ({ product }) => {
  const { name, price, img, "offer-price": offerPrice, id } = product;

  return (
    <div className="item-product">
         <h3 data-name={name}>{name}</h3>
      <div className="img">
        <img src={require(`../assets/products/${img}`)} alt={name} />
      </div>
      {/* Mostrar precios dependiendo de si hay oferta */}
      {id === 0 ? (
        <p className="price">A Consultar</p>
      ) : offerPrice ? (
        <p className='price-offer'>
          <span className="price-new">${offerPrice} c/u</span>
          <span className="price-old">Antes: ${price} c/u</span>
        </p>
      ) : (
        <p className="price">${price} c/u</p>
      )}
      <div className='button'>
        {/* Aquí generamos el enlace para ir a los detalles del producto */}
        <Link to={`/product/${encodeURIComponent(name.toLowerCase().replace(/\s+/g, '-'))}`} className="view-product-button">Más información</Link>
      </div>
    </div>
  );
};

export default ItemProduct;
